export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
  gameCount: number;
}

export const categories: Category[] = [
  { id: 'cat-1', name: '角色扮演', slug: 'rpg', icon: 'ri-sword-line', description: '沉浸式角色扮演游戏，探索奇幻世界', gameCount: 2 },
  { id: 'cat-2', name: '动作冒险', slug: 'action', icon: 'ri-flashlight-line', description: '高自由度动作冒险，畅享战斗快感', gameCount: 2 },
  { id: 'cat-3', name: '恋爱养成', slug: 'romance', icon: 'ri-heart-line', description: '甜蜜恋爱故事，培养专属感情线', gameCount: 2 },
  { id: 'cat-4', name: '策略战争', slug: 'strategy', icon: 'ri-flag-line', description: '运筹帷幄，指挥千军万马', gameCount: 2 },
  { id: 'cat-5', name: '生存冒险', slug: 'survival', icon: 'ri-shield-line', description: '末日求生，挑战极限生存', gameCount: 1 },
  { id: 'cat-6', name: '模拟经营', slug: 'simulation', icon: 'ri-store-line', description: '经营你的世界，感受创造乐趣', gameCount: 2 },
  { id: 'cat-7', name: '射击竞技', slug: 'shooting', icon: 'ri-crosshair-line', description: '激烈枪战对决，展现射击技巧', gameCount: 1 },
];

export const getCategoryBySlug = (slug: string): Category | undefined => categories.find((c) => c.slug === slug);